import React, { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import {
  FooterTop,
  FooterTopLeft,
  FooterTopRight,
  FooterBottom,
  FooterBottomLeft,
  FooterBottomRight,
  Copy,
  List,
  ListItem,
  ListItemLink,
  TopList,
  TopListItem
} from './index.styled'
import Logo from 'icons/logo.svg'

// Logo + link blocks shared by the Footer section and the mobile menu panel.
// Rendered as a fragment so each host supplies its own wrapper and padding.
const FooterContent = () => {
  const currentYear = useMemo(() => new Date().getFullYear(), [])

  // Footer content is a global Single Type in Strapi. Gatsby extracts this
  // query at build time, so the link fields are spelled out per list — the
  // graphql tag takes no interpolation.
  const { strapiFooter } = useStaticQuery(graphql`
    query FooterDataQuery {
      strapiFooter {
        ProjectLinks {
          id
          Title
          Type
          Page {
            Path
          }
          URL
          File {
            localFile {
              publicURL
            }
          }
          SectionId
        }
        PageLinks {
          id
          Title
          Type
          Page {
            Path
          }
          URL
          File {
            localFile {
              publicURL
            }
          }
          SectionId
        }
        BottomLinks {
          id
          Title
          Type
          Page {
            Path
          }
          URL
          File {
            localFile {
              publicURL
            }
          }
          SectionId
        }
      }
    }
  `)

  const projectLinks = strapiFooter?.ProjectLinks || []
  const pageLinks = strapiFooter?.PageLinks || []
  const bottomLinks = strapiFooter?.BottomLinks || []

  return (
    <>
      <FooterTop>
        <FooterTopLeft>
          <img src={Logo} alt='Echelon Studios' />
        </FooterTopLeft>
        <FooterTopRight>
          <TopList>
            {projectLinks.map((link, index) => (
              <TopListItem key={link.id || index}>
                <ListItemLink data={link} />
              </TopListItem>
            ))}
          </TopList>
          {!!pageLinks.length && (
            <TopList>
              {pageLinks.map((link, index) => (
                <TopListItem key={link.id || index}>
                  <ListItemLink data={link} />
                </TopListItem>
              ))}
            </TopList>
          )}
        </FooterTopRight>
      </FooterTop>
      <FooterBottom>
        <FooterBottomLeft>
          <Copy>© {currentYear} ECHELON Management Group</Copy>
        </FooterBottomLeft>
        <FooterBottomRight>
          <List>
            {bottomLinks.map((link, index) => (
              <ListItem key={link.id || index}>
                <ListItemLink data={link} />
              </ListItem>
            ))}
          </List>
        </FooterBottomRight>
      </FooterBottom>
    </>
  )
}

export default FooterContent
